import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const BASE_URL = "https://han-kung.ch";
const PAGES = {
  "/": ["Han Kung Restaurant Chur", "Authentische kantonesische Küche am Kornplatz 12 in Chur."],
  "/menu": ["Speisekarte | Han Kung Chur", "À-la-carte-Gerichte, Mittagsmenüs und Spezialitäten des Han Kung Restaurants."],
  "/reservation": ["Tisch reservieren | Han Kung Chur", "Reservieren Sie Ihren Tisch im Han Kung Restaurant in Chur online."],
  "/takeaway": ["Take Away bestellen | Han Kung Chur", "Chinesische Gerichte online auswählen und am Kornplatz 12 abholen."],
  "/gallery": ["Galerie | Han Kung Chur", "Einblicke in das Han Kung Restaurant und unsere kantonesischen Spezialitäten."],
  "/contact": ["Kontakt | Han Kung Chur", "Kontakt, Adresse und Öffnungszeiten des Han Kung Restaurants in Chur."],
  "/impressum": ["Impressum | Han Kung Chur", "Impressum des Han Kung Restaurants in Chur."],
  "/privacy": ["Datenschutz | Han Kung Chur", "Datenschutzerklärung des Han Kung Restaurants in Chur."],
};

export default function Seo() {
  const { pathname } = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    const canonicalPath = pathname === "/" ? "" : pathname.replace(/\/$/, "");
    const canonicalUrl = `${BASE_URL}${canonicalPath}`;
    const pagePath = (canonicalPath.replace(/^\/(de|en|fr|it|zh)(?=\/|$)/, "") || "/");
    const [title, description] = PAGES[pagePath] || PAGES["/"];
    document.title = title;
    document.documentElement.lang = lang === "zh" ? "zh-Hant" : lang;

    const setMeta = (selector, attr, value) => {
      const element = document.head.querySelector(selector);
      if (element) element.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", description);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonicalUrl);
    setMeta('meta[property="og:image"]', "content", `${BASE_URL}/images/restaurant_service.png`);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);
    setMeta('meta[name="twitter:image"]', "content", `${BASE_URL}/images/restaurant_service.png`);
    setMeta('meta[name="robots"]', "content", pathname.startsWith("/admin") ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", canonicalUrl);

    document.head.querySelectorAll('link[data-hreflang="true"]').forEach(node => node.remove());
    if (!pathname.startsWith("/admin")) {
      const languages = { de: "de-CH", en: "en", fr: "fr-CH", it: "it-CH", zh: "zh-Hant" };
      Object.entries(languages).forEach(([code, hreflang]) => {
        const link = document.createElement("link");
        link.rel = "alternate";
        link.hreflang = hreflang;
        link.href = `${BASE_URL}/${code}${pagePath === "/" ? "" : pagePath}`;
        link.dataset.hreflang = "true";
        document.head.appendChild(link);
      });
      const fallback = document.createElement("link");
      fallback.rel = "alternate";
      fallback.hreflang = "x-default";
      fallback.href = `${BASE_URL}${pagePath === "/" ? "" : pagePath}`;
      fallback.dataset.hreflang = "true";
      document.head.appendChild(fallback);
    }
  }, [pathname, lang]);

  return null;
}
